<div class="container-fluid main-row my-auto py-xl-4 px-0">
  @if (loaded) {
  <div class="row main-row">
    @if (site.id !== -1) {
    <div
      class="col-12 col-lg-10 col-xl-8 title-container mx-auto text-center mt-4 mt-lg-5 mb-4 mb-lg-4"
    >
      <div class="border-box border border-white">
        <h1 class="text-warning font-italic title-top">Entérate y comparte</h1>

        <h5 class="font-italic text-white title-bottom">
          La siguiente información con tu equipo de tienda para
          <strong> INCREMENTAR </strong> tu posibilidad de
          <strong> GANAR </strong>
        </h5>
      </div>
    </div>

    <div class="col-12 mt-4 mt-lg-5 mt-xl-0">
      <div class="frames-container">
        @for (module of site.modules; track $index) {
        <!--  -->
        @if (module.type | moduleImage) {
        <div class="col-auto frame-box">
          <img
            [src]="module.type | moduleImage"
            [alt]="module.type | moduleName"
            (click)="
              open(
                content,
                $index,
                module.content === 'video' ? module.data.video : ''
              )
            "
          />
        </div>
        }
        <!--  -->
        }
      </div>
    </div>
    } @else {
    <div class="col-12 my-auto">
      <h2 class="text-center text-white">No disponible</h2>
    </div>
    }
  </div>
  }
</div>

<ng-template #content let-modal>
  <div class="modal-header text-bg-primary" data-bs-theme="dark">
    <h4 class="modal-title" id="modal-basic-title">
      {{ site.modules[active].type | moduleName }}
    </h4>

    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss()"
    ></button>
  </div>

  <div class="modal-body">
    <div class="row py-3 py-lg-4">
      @switch (site.modules[active].content) {
      <!--  -->
      @case ('pdf') {
      <!--  -->
      @if (site.modules[active].data.pdf) {
      <div class="col-12 text-center mb-4">
        <div class="pdf-container">
          <pdf-viewer
            [src]="site.modules[active].data.pdf"
            [original-size]="false"
            [autoresize]="true"
            [zoom-scale]="isMobile ? 'page-width' : 'page-height'"
            [style]="
              isMobile
                ? 'width: 100%; height: 380px'
                : 'width: 100%; height: 600px'
            "
          ></pdf-viewer>
        </div>
      </div>

      <div class="col-6 col-lg-4 mx-auto mb-4">
        <a
          class="btn btn-primary w-100"
          [href]="site.modules[active].data.pdf"
          target="_blank"
          rel="noopener noreferrer"
          download
        >
          Descargar
        </a>
      </div>
      }
      <!--  -->
      } @case ('html') {
      <!--  -->
      @if (site.modules[active].data.html) {
      <div class="col-12">
        <div [innerHTML]="site.modules[active].data.html"></div>
      </div>
      }
      <!--  -->
      } @case ('video') {
      <!--  -->
      @if (site.modules[active].data.video) {
      <div class="col-12">
        <div class="video-container">
          <div
            id="player"
            [ngStyle]="{
              'position': 'absolute',
              'width.%': 100,
              'height.%': 100,
              'top': 0,
              'left': 0,
            }"
          ></div>
        </div>
      </div>
      } } @case ('excel') {
      <!--  -->
      @if (ranking.length > 0) {
      <div class="col-lg-10 col-xl-8 mx-auto">
        <ol class="list-group">
          @for (item of ranking; track $index) {

          <li
            class="list-group-item d-flex flex-column flex-md-row align-items-start py-2"
          >
            <div class="me-auto mb-2 mb-md-0">
              <div class="font-semibold mb-2">
                Mécanica: <span class="text-primary">{{ item.mechanic }}</span>
              </div>
              <div class="mb-2">
                <strong>Num. Semana:</strong> {{ item.week }}
              </div>
              <div class="mb-2">
                <strong>Fecha de inicio:</strong> {{ item.start }}
              </div>

              <div><strong>Fecha de fin:</strong> {{ item.end }}</div>

              @if (item.bases) {
              <div class="mt-2"><strong>Bases:</strong> {{ item.bases }}</div>
              } @if (item.packs) {
              <div class="mt-2">
                <strong>Venta semana (packs):</strong> {{ item.packs }}
              </div>
              }
            </div>

            <h4 class="mx-auto mx-md-0 mb-0">
              <span class="badge text-bg-primary rounded-pill">
                {{ item.prize | currency }}
              </span>
            </h4>
          </li>
          }
        </ol>
      </div>
      } }
      <!--  -->
      }
    </div>
  </div>

  <div class="modal-footer">
    <div class="row">
      <div class="col-6 col-lg-4 mx-auto">
        <button
          class="btn btn-primary w-100"
          type="button"
          (click)="modal.dismiss()"
        >
          CERRAR
        </button>
      </div>
    </div>
  </div>
</ng-template>
